export default {
  title: 'Aktiver reservationer',
  buttons: {
    cancel: 'Annuller',
    activate: 'Aktiver reservationer',
  },
};
